import { AppProvider, useAppContext } from './context/AppContext';
import Sidebar from './components/chat/Sidebar';
import ChatHeader from './components/chat/ChatHeader';
import MessageList from './components/chat/MessageList';
import InputArea from './components/chat/InputArea';
import AuthPage from './pages/AuthPage'; 
import Modal from './components/ui/Modal';
import AddUserForm from './components/chat/AddUserForm';
import DocumentPreviewer from './components/documents/DocumentPreviewer';
import UploadModal from './components/documents/UploadModal';
import './App.css';

const ChatContainer = () => {
  const {
    theme,
    isAddUserModalOpen,
    closeAddUserModal,
    isSidebarOpen,
    isDocumentModalOpen,
    closeDocumentModal,
    documentPreviewTarget,
    isUploadModalOpen,
    closeUploadModal,
  } = useAppContext();

  return (
      <section className="flex flex-col min-h-screen items-center justify-center">
        <div className={`fixed top-0 left-0 w-screen h-screen z-[51] flex ${theme === 'dark' ? 'bg-gray-900' : 'bg-white'} overflow-hidden transition-all duration-300 chat-container rounded-none`}>
          <Sidebar />
          <div className={`flex-1 flex flex-col ${theme === 'dark' ? 'bg-gray-950' : 'bg-gray-50'} transition-all duration-300 ${
            isSidebarOpen ? 'ml-0' : 'ml-[-300px]'
          }`}>
            <ChatHeader />
            <MessageList />
            <InputArea />
          </div>
        </div>
        <Modal 
          isOpen={isAddUserModalOpen} 
          onClose={closeAddUserModal} 
          title="Add a New User"
        >
          <AddUserForm />
        </Modal>
        <DocumentPreviewer
          isOpen={isDocumentModalOpen}
          onClose={closeDocumentModal}
          initialDocName={documentPreviewTarget}
        />
        <UploadModal isOpen={isUploadModalOpen} onClose={closeUploadModal} />
      </section>
  );
};

const AppContent = () => {
  const { isAuthenticated, appLoading } = useAppContext();

  if (appLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p>Loading...</p>
      </div>
    );
  }

  return isAuthenticated ? <ChatContainer /> : <AuthPage />;
};




const App = () => {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
};

export default App;
